import React, { useMemo } from 'react';
import { Icon, ListItemText, Tooltip } from '@mui/material';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import AppBadge from '@crema/core/AppBadge';
import AppNavLink from '@crema/core/AppNavLink';
import Box from '@mui/material/Box';
import { checkPermission } from '../../../../../utility/helper/RouteHelper';
import { useAuthUser } from '../../../../../utility/AuthHooks';
import VerticalNavItem from './VerticalNavItem';
import { toggleNavCollapsed } from 'redux/actions';
import { useDispatch } from 'react-redux';
import { setModeApp } from 'redux/actions/ModeApp';
import * as icon from '@mui/icons-material';

const checkAccess = (userRoles, menuRoles) => {
  let permit = false;
  for (const value of menuRoles) {
    if (userRoles.includes(value)) {
      permit = true;
      break;
    }
  }
  return permit;
};

const VerticalItem = ({ level, item }) => {
  const dispatch = useDispatch();
  const { user } = useAuthUser();
  const hasPermission = useMemo(
    () => checkPermission(item.permittedRole, user.role),
    [item.permittedRole, user.role],
  );
  if (!hasPermission) {
    return null;
  }

  if (user.roles_access.includes('CRSFE_ADMIN_PENOMORAN')) {
    if (item.id === 'app-portal') return null;
  }

  if (item.role_access && !item.id.includes('app-produk-hukum')) {
    const roleAccess = checkAccess(user.roles_access, item.role_access);
    if (!roleAccess) return null;
  }

  const handleClick = (url) => {
    if (url === '/apps/KnowledgeManagement') {
      sessionStorage.setItem("reloadLiniMasa", true);
    }
    if (item.isNewWindow === '1') {
      window.open(item.url);
    }

    if (item.isAction) {
      if (item.id === 'app-admintools') {
        dispatch(setModeApp('admintools'));
      } else if (item.id === 'app-portal') {
        dispatch(setModeApp('portal'));
      }
    }
    // Close sidebar menu every item clicked
    dispatch(toggleNavCollapsed())
  };

  let toProps = {
  }

  let nip_login = user.nip;
  let email_login = user.email;
  if (item.isNewWindow !== '1' && item.isAction !== '1') toProps.to = item.url;
  if (item.id === 'app-admintools') toProps.to = '/apps/admintools/employee';
  if ((item.id === 'app-admintools') && (user.roles_access.includes('CRSFE_ADMIN_PENOMORAN'))) toProps.to = '/apps/admintools/penomoran';
  if (item.id === 'app-portal') toProps.to = '/kkp';
  if (item.id === 'app-repository') item.url += '&nip_login=' + nip_login + '&email_login=' + email_login + '&keycloak_id=keycloack-' + user.keycloack_id;
  if (item.id === 'chat') item.url += '&nip_login=' + nip_login + '&email_login=' + email_login + '&keycloak_id=keycloack-' + user.keycloack_id;

  const IconComponent = icon[item?.icon];

  return (
    <VerticalNavItem
      level={level}
      button
      component={AppNavLink}
      id={item.id}
      activeClassName={item.isNewWindow === '1' || item.isAction === '1' ? '' : 'active'}
      exact={item.exact}
      // sx={{ paddingLeft: item.id === 'dashbor-lpmukp' ? '3rem !important' :'' ,}}
      onClick={() => handleClick(item.url)}
      {...toProps}
    >
      {item.icon && (
        <Box component='span' sx={{ width: 30, height: 30, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 3 }}>
          <Icon
            color='action' className={clsx('nav-item-icon')}
            sx={{
              fontSize: { xs: 16, xl: 18 },
            }}
          >
            <IconComponent sx={{ fontSize: '20px' }} />
          </Icon>
        </Box>
      )}
      {
        item.tooltip &&
        <Tooltip title={item.tooltip} placement='top' arrow>
          <ListItemText
            className='nav-item-content'
            primary={item.messageId}
            classes={{ primary: 'nav-item-text' }}
            style={{ wordWrap: 'break-word !important', whiteSpace: 'pre-wrap !important' }}
          />
        </Tooltip>
      }
      {
        !item.tooltip &&
        <ListItemText
          className='nav-item-content'
          primary={item.messageId}
          classes={{ primary: 'nav-item-text' }}
          sx={{ wordWrap: 'break-word !important', whiteSpace: 'pre-wrap !important' }}
        />
      }

      {item.count && (
        <Box sx={{ mr: 3.5 }} className='menu-badge'>
          <AppBadge count={item.count} color={item.color} />
        </Box>
      )}
    </VerticalNavItem>
  );
};

VerticalItem.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string,
    icon: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
    permittedRole: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
    exact: PropTypes.bool,
    messageId: PropTypes.string,
    count: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    url: PropTypes.string,
    color: PropTypes.string,
    isNewWindow: PropTypes.any,
    isAction: PropTypes.any,
    role_access: PropTypes.any,
    tooltip: PropTypes.string
  }),
  level: PropTypes.number,
};

VerticalItem.defaultProps = {};

export default React.memo(VerticalItem);
